import * as React from "react";
import DOMPurify from "dompurify";
import { cls } from "@utdanningsdirektoratet/utils/cls";
import styles from "./RichText.module.less";
import "froala-editor/js/plugins.pkgd.min.js";
import "froala-editor/js/languages/nb.js";

import baseDomPurifyConfig from "./baseDomPurifyConfig";
import { Config } from "./types";

type RichTextViewProps = {
  html: string;
  className?: string;
  withoutFroalaClass?: boolean;
  document?: boolean;
  config?: Partial<Config>;
  tag?: keyof JSX.IntrinsicElements;
};

const sanitizeHTML = (value: string, config: Partial<Config>): string => {
  // DOMPurify doesn't allow <annotation> tags for some reason. LANCE uses <annotation> so we have to do a hack to make them work together
  // https://github.com/cure53/DOMPurify/issues/719
  const tempValue = (value ?? "").replace(/<annotation/gi, "<annotations").replace(/<\/annotation/gi, "</annotations");
  const sanitized = DOMPurify.sanitize(DOMPurify.sanitize(tempValue, config) as string, config) as string;
  return sanitized.replace(/<annotations/gi, "<annotation").replace(/<\/annotations/gi, "</annotation");
};

const RichTextView: React.FC<RichTextViewProps> = ({
  className,
  html,
  config = baseDomPurifyConfig,
  document,
  tag: Wrapper = "div",
  withoutFroalaClass,
}) => {
  const viewClass = cls(
    {
      "fr-view": !withoutFroalaClass,
      [styles.richText]: true,
      [styles.richTextView]: true,
      [styles.richTextDocument]: document,
    },
    className
  );

  const getTrustedHtml = (): { __html: string } => {
    return { __html: sanitizeHTML(html, config) as string };
  };

  return <Wrapper className={viewClass} dangerouslySetInnerHTML={getTrustedHtml()} />;
};

export default RichTextView;
